define('views/modules/profile/edit/preferences-edit-panel-personal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // events
    'services/events/user-events',
    // views
    'views/parts/panel/base-panel',
    'views/modules/profile/edit/preferences-edit-content-personal',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // events
    UserEvents,
    // views
    VBasePanel,
    VPreferencesEditContentPersonal
) {

    var VPreferencesPanelPersonal = VBasePanel.extend({
        header: {
            title: "Preferences",
            subtitle: "Edit your preferences",
        },
        tabs: [{ id: 'preferences', title: 'Preferences', active: true }],
        content: {
            preferences: VPreferencesEditContentPersonal
        },
        defaultView: 'preferences',
        initialize: function(opt) {
            var preferences = this.getView('preferences', {
                model: this.model,
                group: opt.group
            });
            this.listenTo(preferences, { 'form:success': this.close });
            this.listenTo(UserEvents, { 'zoomUpdated': this.close });
        },

    });

    return VPreferencesPanelPersonal;
});

